"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const snfCostReportAdmissions = {
    name: 'snf-cost-report-admissions',
    tableType: 'fact',
    grain: [
        'facility::key',
        'year::key'
    ],
    tableGrain: [
        '!facility',
        'year_key',
    ],
    foreignKeys: [
        'facility::key'
    ],
};
const snfCostReportBeds = {
    name: 'snf-cost-report-beds',
    tableType: 'fact',
    grain: [
        'facility::key',
        'year::key'
    ],
    tableGrain: [
        '!facility',
        'year_key',
    ],
    foreignKeys: [
        'facility::key'
    ],
};
const snfCostReportDays = {
    name: 'snf-cost-report-days',
    tableType: 'fact',
    grain: [
        'facility::key',
        'year::key'
    ],
    tableGrain: [
        '!facility',
        'year_key',
    ],
    foreignKeys: [
        'facility::key'
    ],
};
const snfCostReportDischarges = {
    name: 'snf-cost-report-discharges',
    tableType: 'fact',
    grain: [
        'facility::key',
        'year::key'
    ],
    tableGrain: [
        '!facility',
        'year_key',
    ],
    foreignKeys: [
        'facility::key'
    ],
};
const snfCostReportFinancials = {
    name: 'snf-cost-report-financials',
    tableType: 'fact',
    grain: [
        'facility::key',
        'year::key'
    ],
    tableGrain: [
        '!facility',
        'year_key',
    ],
    foreignKeys: [
        'facility::key'
    ],
};
const snfCostReportFTES = {
    name: 'snf-cost-report-ftes',
    tableType: 'fact',
    grain: [
        'facility::key',
        'year::key'
    ],
    tableGrain: [
        '!facility',
        'year_key',
    ],
    foreignKeys: [
        'facility::key'
    ],
};
exports.default = [
    snfCostReportAdmissions,
    snfCostReportBeds,
    snfCostReportDays,
    snfCostReportDischarges,
    snfCostReportFinancials,
    snfCostReportFTES
];
